import {useEffect, useState} from 'react'
import {storage} from '@/services/storage'

export const useLocalStorageBoolean = (key: string, defaultValue = false) => {
    const read = () => Boolean(storage.get(key))

    const [value, setValue] = useState<boolean>(read)

    useEffect(() => {
        const sync = () => setValue(read())

        window.addEventListener('storage', sync)
        return () => window.removeEventListener('storage', sync)
    }, [key])

    return value
}
